import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { courseAPI } from '../../services/api';
import { LoadingSpinner, EmptyState } from '../../components/UI';

const TrainerCourses = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await courseAPI.myAsTrainer();
        setCourses(data);
      } catch (e) { toast.error('Failed to load'); }
      finally { setLoading(false); }
    })();
  }, []);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="container">
      <div className="page-header">
        <div>
          <h1 style={{ color: 'var(--green)' }}>My Courses</h1>
          <p className="subtitle">{courses.length} assigned</p>
        </div>
      </div>

      {courses.length === 0 ? (
        <EmptyState icon="📚" title="No courses yet" message="Contact admin to be assigned to courses" />
      ) : (
        <div className="grid grid-3">
          {courses.map((c) => (
            <div key={c._id} className="course-card">
              <div className="thumb">{c.title.charAt(0)}</div>
              <div className="body">
                <span className="category">{c.category} · {c.level}</span>
                <h3>{c.title}</h3>
                <p className="desc">{c.description}</p>
                <div className="meta">
                  <span>{c.modules?.length || 0} modules</span>
                  <span>${c.price || 'Free'}</span>
                </div>
                {c.modules?.length > 0 && (
                  <details className="mt-2" style={{ fontSize: '0.85rem' }}>
                    <summary style={{ cursor: 'pointer', fontWeight: 600 }}>View modules</summary>
                    <ul className="mt-1" style={{ listStyle: 'none', paddingLeft: 0 }}>
                      {c.modules.map((m, i) => (
                        <li key={i} className="mt-1">
                          <strong>{i + 1}. {m.title}</strong>
                          <div className="text-muted">{m.lessons.length} lessons</div>
                        </li>
                      ))}
                    </ul>
                  </details>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TrainerCourses;
